import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'
import ContainerVoucherData from './ContainerVoucherData'
import { dateFormat, timeFormat } from '../helpers'

const ContainerVoucher = props => {
  return (
    <div className={props.classes.voucher}>
      <Typography className={props.classes.voucherLabel}>
        <div className={props.classes.voucherLabelBetween}>
          <b className={props.classes.voucherCode}>Albarán {props.data.code}</b>
          <b className={props.classes.voucherCode}>{dateFormat(props.data.date)} {timeFormat(props.data.time)}</b>
        </div>
        <div className={props.classes.voucherData}>
          <ContainerVoucherData
            lines={props.data.lines}
            vehicle_plate={props.data.vehicle_plate}
            trailer_plate={props.data.trailer_plate}
            observations1={props.data.observations1}
            observations2={props.data.observations2}
          />
        </div>
      </Typography>
    </div>
  )
}

const styles = {
  voucher: {
    backgroundImage: 'linear-gradient(-180deg, #A9A9A9 0%, #EBEBEB 100%)',
    width: '100%',
  },
  voucherLabel: {
    padding: 10,
    color: 'white',
    fontSize: 13,
    fontWeight: 300
  },
  voucherLabelBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  voucherCode: {
    fontWeight: 400
  },
  voucherData: {
    color: 'rgb(50,50,50)'
  }
}

export default withStyles(styles)(ContainerVoucher)



// WEBPACK FOOTER //
// ./src/components/ContainerVoucher.js